/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { ChartPieComponent } from '../components/common/component/ChartPieComponent';
import DetailIcon from '../assets/Table/showDetails.svg';
import { MilieuApi } from '../utils/api';
import Loader from 'saur_ui_library/src/Atoms/Loader/Loader';
import { dataFormated } from '../utils/helpers/view/dilutionHelper';

export const DilutionDetail = (props: any) => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getDataForGraphics = async () => {
    setLoading(true);
    if (props.row.DilutionRecordDate !== null && props.row.Code !== null) {
      try {
        const response = await MilieuApi.getDetailGraphics(
          props.row.Code,
          new Date(props.row.DilutionRecordDate).getFullYear().toString()
        );
        setData(dataFormated(response.data));
      } catch(error) {
        console.log('Error API !');
      }
    } else {
      console.log('No data for resquesting API !');
    }
  };

  useEffect(() => {
    getDataForGraphics().then(()=>setLoading(false));
  }, []);

  return (
    <>
      {/* Header */}
      <div
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '10px',
        }}
      >
        {/* Title : name of installation */}
        <div
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <img src={DetailIcon} alt='' style={{ marginRight: '5px' }}></img>
          <Word
            value={'Graphique  - ' + props.row.Description}
            variant='p'
          ></Word>
        </div>
        <br />
        <div style={{ textAlign: 'center' }}>
          <Word
            value={
              'Vision détaillée pour les calculs avec la méthode de dilution'
            }
            variant='h1'
          ></Word>
        </div>
        {/* Body */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {loading === true && (
            <div style={{ transform: 'scale(2)', paddingTop: '25px' }}>
              <Loader />
            </div>
          )}
          {/* graphic */}
          {loading === false &&
            (data.length !== 0 ? (
              ChartPieComponent(data, {
                innerRadius: 130,
                fontSizeGraphic: '12px',
                fontSizeTitle: '20px',
              })
            ) : (
              <div>
                <br />
                <span style={{ color: 'red' }}>Aucune données !</span>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};
